import { render, staticRenderFns } from "./nosotros.vue?vue&type=template&id=b7dcb0c8&scoped=true"
import script from "./nosotros.vue?vue&type=script&lang=js"
export * from "./nosotros.vue?vue&type=script&lang=js"
import style0 from "./nosotros.vue?vue&type=style&index=0&id=b7dcb0c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7dcb0c8",
  null
  
)

export default component.exports